import "./styles.scss";

import React from "react";
import clsx from "clsx";

import AnimatedGradient from "components/AnimatedGradient";

const AnimatedIntersection = ({
  id,
  type: Type = "section",
  title,
  className,
  options,
  children,
  childrenHeader,
  variant,
  isContainerless,
  isHero,
}) => {
  return (
    <Type
      className={clsx(
        "animated-intersection",
        className && className,
        variant && `animated-intersection--${variant}`,
        isHero && "animated-intersection--hero"
      )}
    >
      <div className="animated-intersection__header">
        {(title || childrenHeader) && (
          <div className="container">
            {childrenHeader ? childrenHeader : <h3>{title}</h3>}
          </div>
        )}
        <AnimatedGradient id={id} options={options} />
      </div>
      <div className="animated-intersection__body">
        {isContainerless ? (
          children
        ) : (
          <div className="container">{children}</div>
        )}
      </div>
    </Type>
  );
};

export default AnimatedIntersection;
